import { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Module-level cache so all components share one fetch
let cached = null;
let inflight = null;
const subscribers = new Set();

const fetchOnce = () => {
  if (cached) return Promise.resolve(cached);
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/reviews`)
    .then((res) => {
      cached = {
        rating: res.data?.rating ?? null,
        total: res.data?.user_ratings_total ?? null,
        url: res.data?.url ?? null,
      };
      subscribers.forEach((cb) => cb(cached));
      return cached;
    })
    .catch(() => {
      cached = { rating: null, total: null, url: null };
      return cached;
    })
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

/**
 * useGoogleRating
 * Returns { rating, total, url } from Google Places, shared across all callers.
 * Falls back to nulls if API not configured.
 */
export const useGoogleRating = () => {
  const [data, setData] = useState(cached);

  useEffect(() => {
    let active = true;
    if (!cached) {
      fetchOnce().then((d) => {
        if (active) setData(d);
      });
    }
    const cb = (d) => active && setData(d);
    subscribers.add(cb);
    return () => {
      active = false;
      subscribers.delete(cb);
    };
  }, []);

  return data || { rating: null, total: null, url: null };
};
